import React from 'react'
import PropTypes from 'prop-types'

import { BadgePill, Icon } from '../../../index'
import { CustomSelectbox } from '../../Form'
import { useTranslation } from '../../../../utils/providers'
import { trackProductListFilterChange } from '../../../../utils/Alphapet/tracking'

function MultiSelectFilter({
  title,
  fieldId,
  values,
  selectedValues,
  submitForms,
  categoryUrls,
  searchData,
}) {
  const { t } = useTranslation()

  const formData = {
    name: fieldId,
    value: selectedValues,
  }

  const options = Object.values(values)
    .filter(({ count }) => count > 0)
    .sort((a, b) => a.position > b.position)
    .map(({ key }) => ({
      label: key,
      value: key,
    }))

  // Disable when there is only one available option
  const disabled = options.length < 2 && values[options[0].value].count < 2

  const handleChange = (e) => {
    // Immediate submit
    submitForms({ resetPagination: true })
    trackProductListFilterChange(
      e.currentTarget?.value,
      categoryUrls,
      searchData,
      e.target?.value?.includes?.(e.currentTarget)
    )
  }

  return (
    <CustomSelectbox
      data={formData}
      options={options}
      onChange={handleChange}
      multiple={true}
      disabled={disabled}
      renderLabel={({ value, labelId }) => (
        <span className="d-flex align-items-center" id={labelId}>
          <span className="sr-only">
            {t('PRODUCT_LIST_FILTER_LABEL')(title)}
          </span>
          <span aria-hidden={true}>{title}</span>
          <BadgePill
            variant="primary"
            className={!value?.length ? 'invisible ml-2' : 'ml-2'}
          >
            {value?.length || 0}
          </BadgePill>
          <Icon symbol="cf-chevron-down" className="ml-2" />
        </span>
      )}
    />
  )
}

MultiSelectFilter.propTypes = {
  title: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  values: PropTypes.shape({
    key: PropTypes.any,
    count: PropTypes.number,
    position: PropTypes.number,
  }),
  selectedValues: PropTypes.array,
  submitForms: PropTypes.func.isRequired,
  categoryUrls: PropTypes.any,
  searchData: PropTypes.any,
}

export default MultiSelectFilter
